import throttle from 'lodash/throttle';

export type ExitOptions = {
    threshold: number,
    eventThrottle: number,
    onExitIntent: () => void,
}

export default function watchExitIntent(options: ExitOptions): () => void {
  window.focus();
  const removeEvent = () => window.removeEventListener('mousemove', options.onExitIntent);
  const shouldDisplay = (position: number, movement: number) => position <= options.threshold && movement < 0;

  const mouseDidMove = (event: MouseEvent) => {
    if (shouldDisplay(event.clientY, event.movementY)) {
      options.onExitIntent();
    }
  };

  window.addEventListener('mousemove', throttle(mouseDidMove, options.eventThrottle), false);
  return removeEvent;
}
